<div class="right-panel-header__icon universe-background"
    [class]="objectType"
>
    <i class="icon {{objectType}} {{icon}}"></i>
</div>
<div class="right-panel-header__title">
    <ng-content></ng-content>
</div>
